import { useState } from 'react';
import { ExternalLink, Maximize2, Minimize2, RefreshCw } from 'lucide-react';
import { Button } from '../../components/ui/button';

export const ExternalApp = ({ appUrl, appName }) => {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const handleRefresh = () => {
        setIsLoading(true);
        const iframe = document.getElementById('external-app-iframe');
        if (iframe) {
            iframe.src = iframe.src;
        }
    };

    return (
        <div className={`${isFullscreen ? 'fixed inset-0 z-50 bg-white' : 'p-8'}`} data-testid="external-app-wrapper">
            {/* Toolbar */}
            <div className={`flex items-center justify-between mb-4 ${isFullscreen ? 'p-4 border-b border-slate-200' : ''}`}>
                <div className="flex items-center gap-3">
                    <h2 className="text-lg font-semibold text-slate-900">{appName}</h2>
                    <span className="text-xs px-2 py-1 bg-slate-100 text-slate-600 rounded-full">
                        External App
                    </span>
                </div>
                <div className="flex items-center gap-2">
                    <Button 
                        variant="ghost" 
                        size="sm" 
                        onClick={handleRefresh}
                        data-testid="refresh-app-btn"
                    >
                        <RefreshCw className="w-4 h-4 mr-2" />
                        Refresh
                    </Button>
                    <Button 
                        variant="ghost" 
                        size="sm" 
                        onClick={() => window.open(appUrl, '_blank')}
                        data-testid="open-external-btn"
                    >
                        <ExternalLink className="w-4 h-4 mr-2" />
                        Open in Tab
                    </Button>
                    <Button 
                        variant="outline" 
                        size="sm" 
                        onClick={() => setIsFullscreen(!isFullscreen)}
                        data-testid="fullscreen-btn"
                    >
                        {isFullscreen ? (
                            <><Minimize2 className="w-4 h-4 mr-2" /> Exit Fullscreen</>
                        ) : (
                            <><Maximize2 className="w-4 h-4 mr-2" /> Fullscreen</>
                        )}
                    </Button>
                </div>
            </div>

            {/* Iframe Container */}
            <div className={`relative bg-white rounded-lg border border-slate-200 overflow-hidden ${
                isFullscreen ? 'h-[calc(100vh-80px)]' : 'h-[calc(100vh-12rem)]'
            }`}>
                {isLoading && (
                    <div className="absolute inset-0 flex items-center justify-center bg-slate-50">
                        <div className="flex flex-col items-center gap-3">
                            <div className="w-8 h-8 border-3 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
                            <p className="text-sm text-slate-500">Loading {appName}...</p>
                        </div>
                    </div>
                )}
                <iframe
                    id="external-app-iframe"
                    src={appUrl}
                    className="w-full h-full border-0"
                    onLoad={() => setIsLoading(false)}
                    title={appName}
                    allow="clipboard-write; clipboard-read"
                />
            </div>
        </div>
    );
};

export default ExternalApp;
